import { render, staticRenderFns } from "./discounted-sales.vue?vue&type=template&id=2ddb27b2&scoped=true"
import script from "./discounted-sales.vue?vue&type=script&lang=js"
export * from "./discounted-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb27b2",
  null
  
)

export default component.exports